import { Plus, Upload } from '@ondit/ui'
import { FolderPlus, Table as TableIcon } from '@ondit/ui/icons'
import { type ChromeActionSpec, ResourceChromeFallback } from '@/screens/workspace/components'
import { useT } from '~/core/i18n'

const COLUMNS = [
  { id: 'name', header: 'Name' },
  { id: 'columns', header: 'Columns' },
  { id: 'rows', header: 'Rows' },
  { id: 'created', header: 'Created' },
  { id: 'owner', header: 'Owner' },
  { id: 'updated', header: 'Last Updated' },
]

const ACTIONS: ChromeActionSpec[] = [
  { text: 'Import CSV', icon: Upload },
  { text: 'New folder', icon: FolderPlus },
  { text: 'New table', icon: Plus, variant: 'primary' },
]

export default function TablesLoading() {
  const t = useT()
  return (
    <ResourceChromeFallback
      icon={TableIcon}
      title={t('Tables')}
      columns={COLUMNS.map((column) => ({ ...column, header: t(column.header) }))}
      actions={ACTIONS.map((action) => ({ ...action, text: t(action.text) }))}
      searchPlaceholder={t('Search tables...')}
      hasSort
      hasFilter
    />
  )
}
